// ** Third Party Components
import { Controller } from 'react-hook-form'
import { useQueryClient } from 'react-query'
import AsyncSelect from 'react-select/async'

// ** Reactstrap Imports
import CardAction from '@components/card-actions'
import { Button, CardBody, Col, Input, Label, Row, Spinner } from 'reactstrap'

// ** Utils
import { selectThemeColors } from '@utils'

import { fetchSection } from '../../../../components/react-select/fetchSection'

import { useTranslation } from 'react-i18next'

const CheckSubordinateFlexTimeSearch = ({
  refTableData,
  register,
  clearFilterFormSearch,
  controlFormSearch,
  isSearchDataForSearchForm,
  setIsSearchDataForSearchForm
}) => {
  // react-query
  const queryClient = useQueryClient()

  // const { t } = useTranslation();
  const { t } = useTranslation('Search Filter', {
    keyPrefix: 'Utility.Search Filter'
  })

  // Function
  const onClickSearch = () => {
    setIsSearchDataForSearchForm(true)
    queryClient.invalidateQueries('FLEX_TIME_HISTORY_MANAGER')
    refTableData.current.setSortBy([])
    refTableData.current.gotoPage(0)
  }

  const onClickClear = () => {
    clearFilterFormSearch()
  }

  return (
    <CardAction actions="collapse" title={t('Search filters')}>
      <CardBody className="pt-0">
        <Row className="mt-0">
          <Col className="mb-1" md="3" sm="12">
            <Label className="form-label" for="employeeCode" style={{ fontSize: '16px' }}>
              {t('Employee Id')}
            </Label>
            <Controller
              defaultValue=""
              control={controlFormSearch}
              id="employeeCode"
              name="employeeCode"
              render={({ field }) => <Input placeholder={t('Enter employee id')} {...field} autoComplete="off" />}
            />
          </Col>
          <Col className="mb-1" md="3" sm="12">
            <Label className="form-label" for="employeeName" style={{ fontSize: '16px' }}>
              {t('Employee Name')}
            </Label>
            <Controller
              defaultValue=""
              control={controlFormSearch}
              id="employeeName"
              name="employeeName"
              render={({ field }) => <Input placeholder={t('Enter employee name')} {...field} autoComplete="off" />}
            />
          </Col>

          <Col className="mb-1" md="3" sm="12">
            <Label className="form-label" for="employeeDept" style={{ fontSize: '16px' }}>
              {t('Section')}
            </Label>
            <Controller
              defaultValue=""
              control={controlFormSearch}
              id="employeeDept"
              name="employeeDept"
              render={({ field }) => (
                <AsyncSelect
                  isSearchable
                  isClearable
                  cacheOptions
                  defaultOptions
                  loadOptions={(e) => fetchSection(e)}
                  onChange={(value) => {
                    field.onChange(value)
                  }}
                  value={field.value}
                  getOptionLabel={(e) => e.SECTION}
                  getOptionValue={(e) => e.SECTION}
                  className="react-select"
                  classNamePrefix="select"
                  theme={selectThemeColors}
                  placeholder={t('Select Section')}
                  {...field}
                />
              )}
            />
          </Col>

          <div className="d-flex">
            <Button
              className="me-1"
              color="primary"
              onClick={onClickSearch}
              disabled={isSearchDataForSearchForm}
              outline={isSearchDataForSearchForm}
            >
              {isSearchDataForSearchForm ? (
                <>
                  <Spinner size="sm" />
                  <span className="ms-50">{t('Searching')}</span>
                </>
              ) : (
                <>{t('Search')}</>
              )}
            </Button>
            <Button outline color="secondary" onClick={onClickClear} disabled={isSearchDataForSearchForm}>
              {t('Clear')}
            </Button>
          </div>
        </Row>
      </CardBody>
    </CardAction>
  )
}

export default CheckSubordinateFlexTimeSearch
